import { forwardRef } from 'react';
import { ChevronDown } from '@gjensidige/builders-icons';
import { Button } from '../button/button';
import styles from './chevron.module.css';
import clsx from 'clsx';

export type ChevronProps = React.ComponentPropsWithoutRef<'span'> & {
  open?: boolean;
};

export const Chevron = forwardRef<HTMLSpanElement, ChevronProps>(
  function Chevron({ open, className, ...rest }, ref) {
    return (
      <Button
        as="span"
        className={clsx(styles.chevron, className)}
        icon={<ChevronDown />}
        tracking={false}
        variant="icon"
        pressed={open}
        ref={ref}
        {...rest}
      />
    );
  }
);
